export default "__VITE_ASSET__DZciohIu__"